
<template>
    <div class="share">
        <div class="content">
            <div class="title">
                Share with colleague
            </div>
            <el-form :model="shareInfo" ref="accountForm" :rules="rule" @submit.native.prevent>
                <el-form-item
                    prop="email"
                    :rules="[{ required: true, message: 'Please enter colleague email address', trigger: 'blur' },
                    { pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ , message: 'format valid', trigger: 'blur' }]"
                >
                    <el-input
                        v-model="shareInfo.email"
                        placeholder="Enter colleague's email address..."
                        :maxlength="32"
                        class="width355"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="btns">
                <el-button class="" @click="cancel">Cancel</el-button>
                <el-button class="green" @click="share" :disabled="isSendAjax">Share</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
export default {
    props:{
        info: Object
    },
    data(){
        return{
            shareInfo:{
                email:''
            },
            rule:{},
            isSendAjax:false,
        }
    },
    methods:{
        cancel(){
            this.info.show = false;
            gaAnalyze('lpShareClose'); 
        },
        share(){
            this.$refs['accountForm'].validate((valid) => {
                if(!valid) return;
                gaAnalyze('lpShareSave'); 
                if(this.isSendAjax) return;
                this.isSendAjax = true;
                this.axios.post('/userGroup/user-group/rgUser/sendShareEmailToUser',{email:this.shareInfo.email})
                .then(res => {
                    this.isSendAjax = false;
                    if(res.data.errorCode == '0x0'){
                        this.$message.success('Shared with one person.');
                        
                    }else{
                        this.$message({
                            message: res.data.errorCode,
                            type: 'error',
                            customClass:'app-tips'
                        })
                    }
                })
                this.cancel();
            })
        }
    }
}
</script>
<style lang="less" scoped>
.share{
    .is-disabled{
        background: #6BCB82 !important;
    }
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(54,54,54,0.72);
    top: 0;
    z-index: 3;
    .content{
        margin: 0 auto;
        color: #333;
        background: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-70%);
        border-radius: .04rem;
        z-index: 1;
        padding: .32rem;
        width: 4.2rem;
        .title{
            font-size: .16rem;
            color: #000;
            margin-bottom: .15rem;
        }
        .width355{
            width: 3.55rem;
        }
        .btns{
            text-align: right;
            /deep/.el-button{
                padding: .08rem .1rem;
                color: #666;
                &.green{
                    background: #1EC345;
                    border: 1px solid #1EC345;
                    color: #fff;
                }
            }
        }
    }
}
@media(max-width:760px){
    .share{
        .content{
            width: 90%;
            .width355{
                width: 100%;
            }
        }
    }
    
}
</style>
